import { render } from "./InternalDocuments.vue?vue&type=template&id=e908e1f0"
import script from "./InternalDocuments.vue?vue&type=script&lang=js"
export * from "./InternalDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/InternalDocuments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e908e1f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e908e1f0', __exports__)) {
    console.log('reload')
    api.reload('e908e1f0', __exports__)
  }
  
  module.hot.accept("./InternalDocuments.vue?vue&type=template&id=e908e1f0", () => {
    console.log('re-render')
    api.rerender('e908e1f0', render)
  })

}


export default __exports__